import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-content-section-feathure',
  templateUrl: './content-section-feathure.component.html',
  styleUrls: ['./content-section-feathure.component.css']
})
export class ContentSectionFeathureComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
